import { render } from "./OnboardingBanner.vue?vue&type=template&id=6bf65b08"
import script from "./OnboardingBanner.vue?vue&type=script&lang=js"
export * from "./OnboardingBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__